import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { Modal, Input, H3, Badge, Small } from '@bigcommerce/big-design';

import { assignmentUpdate } from '../../redux/actions/assignments';

const EditAssignmentModal = ({ payload, supplierId, showEditAssignmentModal, setShowEditAssignmentModal, assignment, assignmentName, updateAssignment, bigcommerceSettings, settings }) => {
  const [supplierPrice, setSupplierPrice] = useState(null);
  const [minOrder, setMinOrder] = useState(null);
  const [supplierSku, setSupplierSku] = useState(null);
  const [orderMultiple, setOrderMultiple] = useState(null);
  const [packQuantity, setPackQuantity] = useState(null);

  const clearAndClose = () => {
    setSupplierPrice(null);
    setMinOrder(null);
    setSupplierSku(null);
    setOrderMultiple(null);
    setPackQuantity(null);
    setShowEditAssignmentModal(false);
  }

  const format = (value) => {
    let formattedValue = "";

    if(bigcommerceSettings.currency_symbol_location === 'left') {
      formattedValue += bigcommerceSettings.currency_symbol
    }
    
    formattedValue += parseFloat(value).toFixed(bigcommerceSettings.decimal_places)

    if(bigcommerceSettings.currency_symbol_location !== 'left') {
      formattedValue += bigcommerceSettings.currency_symbol
    }

    formattedValue = formattedValue.replace('.', bigcommerceSettings.decimal_separator)

    return formattedValue;
  }

  const update = () => {
    let assignmentValues = { supplierPrice: supplierPrice, minOrder: minOrder, supplierSku: supplierSku };
    
    if(settings?.settings?.order_multiples) {
      assignmentValues.orderMultiple = orderMultiple;
    }

    if(settings?.settings?.pack_quantities) {
      assignmentValues.packQuantity = packQuantity;
    }

    updateAssignment(payload, supplierId, assignment, assignmentValues);
    clearAndClose();
  }

  const validateQuantity = (event, setField) => {
    let value = event.target.value;
    setField(value.replace(/[^\d.-]+/g, '') || 0.0);
  }

  const validateInteger = (event, setField) => {
    let value = parseInt(event.target.value).toString();
    setField(value || 0);
  }

  const validateValue = (event, setField) => {
    let value = event.target.value;
    setField(value);
  }

  return(
    <Modal
      actions={[
        {
          text: 'Cancel',
          variant: 'subtle',
          onClick: () => clearAndClose(),
        },
        { text: 'Update Assignment Settings', onClick: () => update() },
      ]}
      closeOnClickOutside={true}
      closeOnEscKey={true}
      header="Update Assignment Settings"
      isOpen={showEditAssignmentModal}
      onClose={() => clearAndClose()}
    >
      <H3>{assignmentName}</H3>
      

      <Small>
        Current Supplier SKU: {assignment?.supplier_sku}<br/>
        Current Supplier Price: {assignment?.supplier_price ? format(assignment.supplier_price) : null}<br/>
        Current MOQ: {assignment?.minimum_order}
        { settings?.settings?.order_multiples &&
          <><br/>Current Order Multiple: {assignment?.order_multiple}</>
        }
        { settings?.settings?.pack_quantities &&
          <><br/>Current Pack Quantity: {assignment?.pack_quantity}</>
        }
      </Small>


      <hr/>

      <Input label="Update Supplier SKU" placeholder={assignment?.supplier_sku} id="update_supplier_sku" type="text" value={supplierSku} onChange={(e) => validateValue(e, setSupplierSku)} />
      <Input label="Update Supplier Price" placeholder={assignment?.supplier_price ? format(assignment.supplier_price) : null} id="update_supplier_price" min="0" type="number" value={supplierPrice} onChange={(e) => validateQuantity(e, setSupplierPrice)} />
      <Input label="Update Order Minium Quantity" placeholder={assignment?.minimum_order} id="update_minimum_quantity" step="1" min="0" type="number" value={minOrder} onChange={(e) => validateInteger(e, setMinOrder)} />
      { settings?.settings?.order_multiples && 
        <Input label="Order Multiple" placeholder={assignment?.order_multiple} id="update_order_multiple" min="0" step="1" type="number" value={orderMultiple} onChange={(e) => validateInteger(e, setOrderMultiple)} />
      }
      { settings?.settings?.pack_quantities && 
        <Input label="Pack Quantity" placeholder={assignment?.pack_quantity} id="update_pack_quantity" min="0" step="1" type="number" value={packQuantity} onChange={(e) => validateInteger(e, setPackQuantity)} />
      }

    </Modal>
  )
}

const mapStateToProps = state => ({
  bigcommerceSettings: state.stores.settings,
  settings: state.settings
});

const mapDispatchToProps = (dispatch) => ({
  updateAssignment: (payload, supplierId, assignment, assignmentValues) => dispatch(assignmentUpdate(payload, supplierId, assignment, assignmentValues)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditAssignmentModal);
